<template>
  <div class="project-income-confirmed">
    <el-form ref="searchForm" :inline="true" :model="searchForm" class="searchBoxLine">
      <el-form-item label="合同编号" prop="customerPoCode">
        <el-input v-model.trim="searchForm.customerPoCode" placeholder="请输入合同编号" clearable />
      </el-form-item>
      <el-form-item label="客户名称" prop="customerName">
        <el-input v-model.trim="searchForm.customerName" placeholder="请输入客户名称" clearable />
      </el-form-item>
      <el-form-item label="销售项目名称" prop="projectName">
        <el-input v-model.trim="searchForm.projectName" placeholder="请输入销售项目名称" clearable />
      </el-form-item>
      <el-form-item label="确收规则" prop="acceptanceRule">
        <el-select v-model="searchForm.acceptanceRule" placeholder="请选择确收规则" :clearable="searchForm.acceptanceRule !== '全部'" @clear="handleFilterClear('acceptanceRule')">
          <el-option label="全部" value="全部" />
          <el-option label="到货验收" value="到货验收" />
          <el-option label="初验" value="初验" />
          <el-option label="终验" value="终验" />
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="客户签约类型" prop="customerSignType">
        <el-select v-model="searchForm.customerSignType" placeholder="请选择客户签约类型" :clearable="searchForm.customerSignType !== '全部'" @clear="handleFilterClear('customerSignType')">
          <el-option label="全部" value="全部" />
          <el-option label="直签" value="直签" />
          <el-option label="代理商" value="代理商" />
        </el-select>
      </el-form-item> -->
      <el-form-item label="部门" prop="department">
        <el-input v-model.trim="searchForm.department" placeholder="请输入部门" clearable />
        <el-button type="primary" :loading="isLoading" style="margin-left: 12px;" @click="doSearch">搜索</el-button>
        <el-button @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="notice-bar">
      页面已按合同编号聚合展示，点击查看可查看当前合同编号下全部确收批次的产品行数据，点击确收编码可查看当前批次下的产品行数据。
    </div>

    <div v-loading="isLoading">
      <div v-for="order in tableData" :key="order.id" class="order-card">
        <div class="order-main">
          <div class="order-info">
            <div class="order-title">
              <span>{{ order.customerPoCode }}</span>
              <el-button type="text" class="po-detail-button" @click="openPoDetail(order)">查看</el-button>
              <span class="customer-tag">销售项目名称：{{ order.projectNames }}</span>
            </div>
            <div class="order-meta">
              实际结算金额：{{ formatAmount(order.orderAmount) }} <span>|</span>
              已付款比例：{{ formatRate(order.paidRate) }} <span>|</span>
              已付款金额：{{ formatAmount(order.paidAmount) }}
            </div>
          </div>
          <div class="order-stat-list">
            <div class="order-stat">
              <div class="stat-label">客户名称</div>
              <div class="stat-value">{{ order.customerName }}</div>
            </div>
            <div class="order-stat two">
              <div class="stat-label">确收批次</div>
              <div class="stat-value">{{ order.arItems.length }}</div>
            </div>
            <div class="order-stat three">
              <div class="stat-label">验收金额</div>
              <div class="stat-value">{{ formatAmount(order.confirmAmount) }}</div>
            </div>
            <div class="order-stat two">
              <div class="stat-label">验收数量</div>
              <div class="stat-value">{{ getCurrentConfirmQuantity(order) }}</div>
            </div>
            <div class="order-actions">
              <el-button size="mini" @click="toggleDetail(order)">{{ order.expanded ? '收起确收批次' : '展开确收批次' }}</el-button>
            </div>
          </div>
        </div>

        <el-table v-show="order.expanded" :data="order.arItems" border class="ar-list-table">
          <el-table-column prop="confirmNo" label="确收编码" width="180" align="left">
            <template v-slot="{ row }">
              <el-link type="primary" class="confirm-link" @click="openArDetail(row)">{{ row.confirmNo }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="orderType" label="订单类型" width="150" align="left" />
          <el-table-column prop="projectNames" label="销售项目名称" min-width="220" align="left" />
          <el-table-column label="实际结算金额" width="120" align="right" header-align="left">
            <template v-slot="{ row }">{{ formatAmount(row.paymentAmount) }}</template>
          </el-table-column>
          <el-table-column prop="acceptanceTime" label="确收时间" width="120" align="center" />
          <el-table-column prop="confirmDate" label="确认时间" width="120" align="center" />
          <el-table-column prop="confirmQuantity" label="验收数量" width="100" align="center" />
          <el-table-column label="验收金额" width="100" align="right" header-align="left">
            <template v-slot="{ row }">{{ formatAmount(row.confirmAmount) }}</template>
          </el-table-column>
        </el-table>
      </div>
      <el-empty v-if="!isLoading && tableData.length === 0" description="暂无数据" class="empty-list" />
    </div>

    <div class="pagination-wrap">
      <el-pagination
        :page-sizes="[10, 20, 30, 40]"
        :page-size.sync="page.pageSize"
        :current-page.sync="page.currentPage"
        layout="total, prev, pager, next, jumper,sizes"
        :total="page.total"
        hide-on-single-page
        @size-change="handerSizeChange"
        @current-change="handerCurrentChange"
      />
    </div>

    <el-dialog title="PO子集数据" :visible.sync="detailVisible" width="95vw" class="detail-dialog">
      <div v-if="detailData.customerPoCode">
        <div class="detail-header">
          <div class="detail-item"><span>合同编号：</span>{{ detailData.customerPoCode }}</div>
          <div class="detail-item"><span>销售项目名称：</span>{{ detailData.projectName || '-' }}</div>
          <div class="detail-item"><span>客户名称：</span>{{ detailData.customerName }}</div>
          <div class="detail-item"><span>实际结算金额：</span>{{ formatAmount(detailData.orderAmount) }}</div>
          <div class="detail-item"><span>已验收金额：</span>{{ formatAmount(getConfirmedTotal(detailData.orderLines)) }}</div>
        </div>
        <el-table :data="detailData.orderLines" border class="detail-table" max-height="360">
          <el-table-column prop="confirmNo" label="确收编码" width="160" align="left" />
          <el-table-column prop="deliveryNo" label="发货单号" width="150" align="left" />
          <el-table-column prop="deliveryDate" label="发货日期" width="120" align="left" />
          <el-table-column prop="erpOrderNo" label="ERP订单号" width="160" align="left" />
          <el-table-column prop="orderType" label="订单类型" width="130" align="left" />
          <el-table-column prop="orderLine" label="订单行" width="90" align="left" />
          <el-table-column label="确收规则" width="120" align="left">
            <template v-slot="{ row }">
              <span class="line-status">{{ getAcceptanceRule(row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="materialNum" label="物料编码" width="150" align="left" />
          <el-table-column prop="lineContent" label="物料描述" min-width="240" align="left" />
          <el-table-column label="实际结算金额" width="130" align="right" header-align="left">
            <template v-slot="{ row }">{{ formatAmount(row.orderAmount) }}</template>
          </el-table-column>
          <el-table-column prop="confirmQuantity" label="本次验收数量" width="160" align="center" />
          <el-table-column label="本次验收金额" width="130" align="right" header-align="left">
            <template v-slot="{ row }">{{ formatAmount(row.confirmAmount) }}</template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="确收产品行数据" :visible.sync="arDetailVisible" width="95vw" class="detail-dialog ar-detail-dialog" @close="handleArDetailDialogClose">
      <div v-if="arDetailData.confirmNo">
        <div class="detail-header">
          <div class="detail-item"><span>确收编码：</span>{{ arDetailData.confirmNo }}</div>
          <div class="detail-item"><span>合同编号：</span>{{ arDetailData.customerPoCode }}</div>
          <div class="detail-item"><span>销售项目名称：</span>{{ arDetailData.projectName || '-' }}</div>
          <div class="detail-item"><span>客户名称：</span>{{ arDetailData.customerName }}</div>
          <div class="detail-item"><span>验收金额：</span>{{ formatAmount(arDetailData.confirmAmount) }}</div>
          <div class="detail-item"><span>验收日期：</span>{{ arDetailData.acceptanceTime || '-' }}</div>
          <div class="detail-item"><span>确认日期：</span>{{ arDetailData.confirmDate || '-' }}</div>
          <div class="detail-item"><span>系统接收日期：</span>{{ arDetailData.systemReceiveDate || '-' }}</div>
          <div class="detail-item"><span>验收数量：</span>{{ arDetailData.confirmQuantity }}</div>
        </div>
        <el-table :data="arDetailData.orderLines" border class="detail-table" max-height="360">
          <el-table-column prop="deliveryNo" label="发货单号" width="150" align="left" />
          <el-table-column prop="deliveryDate" label="发货日期" width="120" align="left" />
          <el-table-column prop="erpOrderNo" label="ERP订单号" width="160" align="left" />
          <el-table-column prop="orderLine" label="订单行" width="90" align="left" />
          <el-table-column label="确收规则" width="120" align="left">
            <template v-slot="{ row }">
              <span class="line-status">{{ getAcceptanceRule(row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="materialNum" label="物料编码" width="150" align="left" />
          <el-table-column prop="lineContent" label="物料描述" min-width="240" align="left" />
          <el-table-column label="实际结算金额" width="130" align="right" header-align="left">
            <template v-slot="{ row }">{{ formatAmount(row.orderAmount) }}</template>
          </el-table-column>
          <el-table-column prop="confirmQuantity" label="本次验收数量" width="160" align="center" />
          <el-table-column label="本次验收金额" width="130" align="right" header-align="left">
            <template v-slot="{ row }">{{ formatAmount(row.confirmAmount) }}</template>
          </el-table-column>
        </el-table>
        <div class="detail-attachment-section">
          <div class="detail-attachment-header">
            <div class="detail-attachment-title">验收附件</div>
            <div class="detail-attachment-actions">
              <el-upload
                action="false"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="handleAttachmentUpload"
              >
                <el-button type="primary" plain icon="el-icon-upload2">上传附件</el-button>
              </el-upload>
              <el-button type="primary" :disabled="!attachmentChanged" @click="submitAttachment">提交</el-button>
            </div>
          </div>
          <el-table
            v-if="arDetailAttachmentList.length"
            :data="arDetailAttachmentList"
            border
            size="mini"
            class="attachment-table"
          >
            <el-table-column label="附件名称" min-width="220" align="left">
              <template v-slot="{ row }">
                <span class="attachment-name" @click="handleAttachmentClick(row)">{{ row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="uploader" label="上传人" width="140" align="left" />
            <el-table-column prop="uploadTime" label="上传时间" width="170" align="left" />
            <el-table-column label="操作" width="80" align="center">
              <template v-slot="{ $index }">
                <i class="el-icon-delete attachment-delete" @click="handleRemoveAttachment($index)" />
              </template>
            </el-table-column>
          </el-table>
          <div v-else class="attachment-empty">暂无附件，请点击上方按钮上传。</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeArDetailDialog">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getAcceptanceReceiptPoList, getAcceptanceReceiptPoDetail, getAcceptanceReceiptArDetail, saveAcceptanceReceiptArAttachment, attachmentGetToken } from '@/API';
import AxiosApi from '@/API/fileAxios';

export default {
  data () {
    return {
      isLoading: false,
      searchForm: {
        customerPoCode: '',
        customerName: '',
        projectName: '',
        acceptanceRule: '全部',
        customerSignType: '直签',
        department: ''
      },
      allTableData: [],
      detailVisible: false,
      detailData: {},
      arDetailVisible: false,
      arDetailSource: null,
      arDetailData: {},
      attachmentChanged: false,
      hasInitialAttachments: false,
      pendingAttachmentUrls: [],
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
    };
  },
  computed: {
    tableData () {
      const start = (this.page.currentPage - 1) * this.page.pageSize;
      return this.allTableData.slice(start, start + this.page.pageSize);
    },
    orderLineTotal () {
      return this.allTableData.reduce((total, order) => total + order.orderLines.length, 0);
    },
    arBatchTotal () {
      return this.allTableData.reduce((total, order) => total + order.arItems.length, 0);
    },
    arDetailAttachmentList () {
      return this.arDetailData.attachmentList || [];
    }
  },
  mounted () {
    this.doSearch();
  },
  methods: {
    doSearch () {
      this.isLoading = true;
      getAcceptanceReceiptPoList({
        contractNum: this.searchForm.customerPoCode,
        customerName: this.searchForm.customerName,
        projectName: this.searchForm.projectName,
        acceptanceRule: this.searchForm.acceptanceRule,
        customerContractType: this.searchForm.customerSignType,
        departmentName: this.searchForm.department,
        currentUserId: (window.$core?.user?.userId) || '',
        pageIndex: 1,
        pageSize: 999
      }).then((res) => {
        this.isLoading = false;
        const json = res.data;
        if (json.status === '200') {
          this.page.currentPage = 1;
          this.allTableData = this.normalizePoTableData(json.data.list || []);
          this.page.total = this.allTableData.length;
        } else {
          this.allTableData = [];
          this.page.total = 0;
        }
      }).catch(() => {
        this.isLoading = false;
        this.allTableData = [];
        this.page.total = 0;
      });
    },
    resetForm () {
      this.$refs.searchForm.resetFields();
      this.page.currentPage = 1;
      this.doSearch();
    },
    handleFilterClear (field) {
      this.searchForm[field] = '全部';
    },
    handerSizeChange () {
      this.page.currentPage = 1;
    },
    handerCurrentChange (val) {
      this.page.currentPage = val;
    },
    normalizePoTableData (list) {
      return list.map((order) => {
        const arItems = (order.arItems || []).map((arItem) => ({
          ...arItem,
          confirmNo: arItem.invoiceNo || arItem.confirmNo || '',
          projectNames: arItem.projectName || arItem.projectNames || '',
          orderLines: (arItem.orderLines || []).map((line) => ({
            ...line,
            confirmNo: line.confirmNo || arItem.confirmNo,
            customerPoCode: line.customerPoCode || arItem.customerPoCode || order.customerPoCode,
            customerName: line.customerName || arItem.customerName || order.customerName,
            projectName: line.projectName || arItem.projectNames || order.projectNames,
            confirmDate: line.confirmDate || arItem.confirmDate || order.confirmDate,
            acceptanceTime: line.acceptanceTime || arItem.acceptanceTime || order.confirmDate,
            orderType: line.orderType || arItem.orderType || order.orderType || '',
            acceptanceRule: line.acceptanceRule || line.lineStatus || '',
            lineStatus: line.lineStatus || '已收入确认',
            materialNum: line.materialNum || line.materialNumber || line.material_num || '',
            orderAmount: line.orderAmount || line.confirmAmount,
            confirmableAmount: line.confirmableAmount || line.confirmAmount,
            confirmableQuantity: line.confirmableQuantity || line.confirmQuantity,
            paidAmount: line.paidAmount === undefined ? (line.confirmAmount || 0) : line.paidAmount
          }))
        }));
        return {
          ...order,
          customerPoCode: order.contractNum || order.customerPoCode || '',
          projectNames: order.projectName || order.projectNames || '',
          expanded: false,
          arItems,
          orderLines: arItems.reduce((result, arItem) => result.concat(arItem.orderLines || []), []),
          paidRate: order.paidRate != null ? order.paidRate : (Number(order.orderAmount || 0) ? (Number(order.paidAmount || 0) / Number(order.orderAmount || 1)) * 100 : 0)
        };
      });
    },
    toggleDetail (order) {
      order.expanded = !order.expanded;
    },
    collapseExpandedDetails () {
      this.allTableData.forEach((order) => {
        this.$set(order, 'expanded', false);
      });
    },
    openPoDetail (row) {
      this.isLoading = true;
      getAcceptanceReceiptPoDetail({
        contractNum: row.contractNum || row.customerPoCode,
        currentUserId: (window.$core?.user?.userId) || ''
      }).then((res) => {
        this.isLoading = false;
        const json = res.data;
        if (json.status === '200' && json.data) {
          const data = json.data;
          this.detailData = {
            ...row,
            ...data,
            customerPoCode: row.customerPoCode,
            projectName: data.projectName || row.projectName || row.projectNames || '',
            orderLines: (data.orderLines || []).map((line) => ({
              ...line,
              confirmNo: line.invoiceNo || row.confirmNo,
              customerPoCode: row.customerPoCode,
              customerName: data.customerName || row.customerName,
              projectName: line.projectName || row.projectNames,
              orderType: line.orderType || data.orderType || row.orderType || '',
              acceptanceRule: line.acceptanceRule || line.lineStatus || '',
              materialNum: line.materialNum || line.materialNumber || line.material_num || '',
              lineContent: line.productDescription || line.materialDescription || '',
              lineStatus: line.lineStatus || '已收入确认'
            }))
          };
          this.detailVisible = true;
        } else {
          this.$message.error(json.message || '查询PO明细失败');
        }
      }).catch(() => {
        this.isLoading = false;
        this.$message.error('查询PO明细失败');
      });
    },
    openArDetail (row) {
      this.isLoading = true;
      getAcceptanceReceiptArDetail({
        contractNum: row.contractNum || row.customerPoCode,
        invoiceNo: row.confirmNo || row.invoiceNo,
        currentUserId: (window.$core?.user?.userId) || ''
      }).then((res) => {
        this.isLoading = false;
        const json = res.data;
        if (json.status === '200' && json.data) {
          const data = json.data;
          this.arDetailSource = row;
          this.arDetailData = {
            ...data,
            confirmNo: row.confirmNo || data.invoiceNo,
            customerPoCode: row.customerPoCode || data.contractNum || '',
            projectName: data.projectName || row.projectName || row.projectNames || '',
            orderLines: (data.orderLines || []).map((line) => ({
              ...line,
              confirmNo: data.invoiceNo || row.confirmNo,
              customerPoCode: row.customerPoCode || data.contractNum || line.contractNum || '',
              customerName: data.customerName || row.customerName,
              projectName: line.projectName || row.projectNames,
              orderType: line.orderType || data.orderType || row.orderType || '',
              acceptanceRule: line.acceptanceRule || line.lineStatus || '',
              materialNum: line.materialNum || line.materialNumber || line.material_num || '',
              lineContent: line.productDescription || line.materialDescription || '',
              lineStatus: line.lineStatus || '已收入确认'
            })),
            attachmentList: (data.attachmentList || []).map((item) => ({
              ...item,
              name: item.fileName || item.name,
              url: item.fileUrl || item.url || ''
            }))
          };
          this.attachmentChanged = false;
          this.hasInitialAttachments = this.arDetailData.attachmentList.length > 0;
          this.pendingAttachmentUrls = [];
          this.arDetailVisible = true;
        } else {
          this.$message.error(json.message || '查询AR明细失败');
        }
      }).catch(() => {
        this.isLoading = false;
        this.$message.error('查询AR明细失败');
      });
    },
    cloneArDetailData (row) {
      const source = row || {};
      return {
        ...source,
        orderLines: (source.orderLines || []).map((line) => ({ ...line })),
        attachmentList: (source.attachmentList || []).map((item) => ({ ...item }))
      };
    },
    findArBatch (row) {
      let matched = null;
      this.allTableData.some((order) => {
        matched = (order.arItems || []).find((item) => item.confirmNo === row.confirmNo && item.customerPoCode === row.customerPoCode);
        return Boolean(matched);
      });
      return matched;
    },
    getCurrentConfirmQuantity (order) {
      if (order.arItems) {
        return order.arItems.reduce((total, item) => total + Number(item.confirmQuantity || 0), 0);
      }
      return order.orderLines.reduce((total, line) => total + Number(line.confirmQuantity || 0), 0);
    },
    getAcceptanceRule (row) {
      return row.acceptanceRule || row.lineStatus || '-';
    },
    getConfirmedTotal (list) {
      return (list || []).reduce((total, line) => total + Number(line.confirmAmount || 0), 0);
    },
    handleAttachmentUpload (file) {
      const item = {
        name: file.name,
        url: file.raw ? URL.createObjectURL(file.raw) : '',
        fileToken: '',
        raw: file.raw,
        uploader: (window.$core?.user?.userName) || (window.$core?.user?.userId) || '',
        uploadTime: this.getCurrentDateTime(),
        uploading: true
      };
      if (!this.arDetailData.attachmentList) {
        this.$set(this.arDetailData, 'attachmentList', []);
      }
      if (item.url) {
        this.pendingAttachmentUrls.push(item.url);
      }
      this.arDetailData.attachmentList.push(item);
      this.uploadSingleFile(item);
      this.attachmentChanged = true;
    },
    async uploadSingleFile (item) {
      if (!item.raw) return;
      try {
        const tokenRes = await attachmentGetToken();
        if (tokenRes.data.status !== '200') {
          item.uploading = false;
          this.$message.error('获取上传凭证失败');
          return;
        }
        const { token, uploadUrl, downloadUrl } = tokenRes.data.data;
        const form = new FormData();
        form.append('files', item.raw);
        const uploadRes = await AxiosApi.post(uploadUrl + '?Token=' + token, form, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        if (uploadRes.data.status === '200' && uploadRes.data.data?.[0]) {
          const uploadedFile = uploadRes.data.data[0];
          item.fileToken = uploadedFile.FID;
          item.name = uploadedFile.FullName || item.name;
          item.url = `${downloadUrl}/${item.fileToken}?Token=${token}`;
          item.uploading = false;
        } else {
          item.uploading = false;
          this.$message.error(`文件"${item.name}"上传失败`);
        }
      } catch (e) {
        item.uploading = false;
        this.$message.error(`文件"${item.name}"上传失败`);
      }
    },
    handleAttachmentClick (row) {
      if (row.url) {
        window.open(row.url);
      }
    },
    handleRemoveAttachment (index) {
      this.$confirm('确认删除该附件吗？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const file = this.arDetailData.attachmentList[index];
        if (file && file.url && file.url.indexOf('blob:') === 0) {
          URL.revokeObjectURL(file.url);
          this.pendingAttachmentUrls = this.pendingAttachmentUrls.filter((item) => item !== file.url);
        }
        this.arDetailData.attachmentList.splice(index, 1);
        this.attachmentChanged = true;
      }).catch(() => {});
    },
    submitAttachment () {
      if (!this.arDetailData.attachmentList.length && !this.hasInitialAttachments) {
        this.$message.warning('请至少上传一个附件');
        return;
      }
      const uploading = this.arDetailData.attachmentList.find((f) => f.uploading);
      if (uploading) {
        this.$message.warning('文件正在上传中，请稍候');
        return;
      }
      const attachments = this.arDetailData.attachmentList
        .filter((f) => f.fileToken)
        .map((f) => ({ fileToken: f.fileToken, fileName: f.name, fileUrl: f.url }));
      saveAcceptanceReceiptArAttachment({
        invoiceNo: this.arDetailData.invoiceNo || this.arDetailData.confirmNo,
        currentUserId: (window.$core?.user?.userId) || '',
        currentUserName: (window.$core?.user?.userName) || '',
        attachmentList: attachments
      }).then((res) => {
        const json = res.data;
        if (json.status === '200') {
          if (this.arDetailSource) {
            this.$set(this.arDetailSource, 'attachmentList', this.arDetailData.attachmentList.map((item) => ({ ...item })));
          }
          this.attachmentChanged = false;
          this.$message.success('附件提交成功');
        } else {
          this.$message.error(json.message || '附件保存失败');
        }
      }).catch(() => {
        this.$message.error('附件保存失败');
      });
    },
    closeArDetailDialog () {
      this.arDetailVisible = false;
    },
    handleArDetailDialogClose () {
      this.pendingAttachmentUrls.forEach((url) => {
        URL.revokeObjectURL(url);
      });
      this.pendingAttachmentUrls = [];
      this.attachmentChanged = false;
      this.hasInitialAttachments = false;
      this.arDetailSource = null;
      this.arDetailData = {};
    },
    getCurrentDateTime () {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hour = String(date.getHours()).padStart(2, '0');
      const minute = String(date.getMinutes()).padStart(2, '0');
      const second = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    sumField (list, field) {
      return list.reduce((total, item) => total + Number(item[field] || 0), 0);
    },
    formatRate (value) {
      return `${Number(value || 0).toFixed(2)}%`;
    },
    formatAmount (value) {
      return Number(value || 0).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  }
};
</script>

<style lang="scss" scoped>
.project-income-confirmed {
  padding-bottom: 20px;
}

.search-card {
  margin-bottom: 10px;
}

.page-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 14px;
}

.page-title {
  color: #303133;
  font-size: 16px;
  font-weight: 700;
}

.page-desc {
  margin-top: 6px;
  color: #606266;
  font-size: 12px;
}

.page-summary {
  color: #67c23a;
  background: #f0f9eb;
  border-radius: 4px;
  padding: 8px 14px;
  font-size: 13px;
}

.search-form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.search-form ::v-deep .el-form-item {
  margin-bottom: 10px;
}

.search-form ::v-deep .el-input {
  width: 250px;
}

.notice-bar {
  margin: 10px 0;
  padding: 9px 14px;
  color: #1f7a4d;
  background: #f0f9eb;
  border: 1px solid #b7eb8f;
  border-radius: 6px;
  font-size: 13px;
}

.order-card {
  margin-bottom: 10px;
  padding: 12px 14px 10px;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}

.order-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.order-info {
  min-width: 0;
}

.order-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  color: #303133;
  font-size: 16px;
  font-weight: 700;
}

.po-detail-button {
  margin-left: 8px;
}

.confirm-link {
  font-size: 16px;
  font-weight: 700;
}

.customer-tag {
  display: inline-block;
  margin-left: 10px;
  padding: 2px 8px;
  color: #67c23a;
  background: #f0f9eb;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 400;
}

.order-meta {
  margin-top: 9px;
  color: #62748a;
  font-size: 13px;
}

.order-meta span {
  margin: 0 8px;
  color: #9aa9b8;
}

.order-stat-list {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.order-stat {
  width: 200px;
  margin-left: 10px;
  padding: 12px;
  background: #f5f8fc;
  border-radius: 4px;
}

.order-stat.two {
  width: 85px;
}

.order-stat.three {
  width: 130px;
}

.stat-label {
  color: #8795a5;
  font-size: 12px;
}

.stat-value {
  margin-top: 6px;
  color: #17233d;
  font-size: 16px;
  font-weight: 700;
}

.order-actions {
  display: flex;
  align-items: center;
  margin-left: 14px;
  padding: 12px 0;
}

.ar-list-table {
  margin-top: 12px;
}

.line-status {
  display: inline-block;
  margin-top: 8px;
  padding: 2px 8px;
  color: #67c23a;
  background: #f0f9eb;
  border-radius: 12px;
  font-size: 12px;
}

.pagination-wrap {
  margin-top: 10px;
  text-align: right;
}

.detail-dialog ::v-deep .el-dialog {
  border-radius: 8px;
}

.detail-dialog ::v-deep .el-dialog__body {
  padding-top: 10px;
}

.detail-header {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 28px;
  margin-bottom: 12px;
  color: #606266;
  font-size: 13px;
  line-height: 22px;
}

.detail-item {
  min-width: 260px;
}

.detail-item span {
  color: #303133;
  font-weight: 700;
}

.detail-table {
  margin-top: 8px;
}

.detail-attachment-section {
  padding: 20px 0 0;
}

.detail-attachment-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.detail-attachment-title {
  color: #303133;
  font-size: 14px;
  font-weight: 700;
}

.detail-attachment-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.attachment-table {
  margin-top: 10px;
}

.attachment-name {
  color: #409eff;
  cursor: pointer;
}

.attachment-name:hover {
  text-decoration: underline;
}

.attachment-delete {
  color: #f56c6c;
  cursor: pointer;
  font-size: 16px;
}

.attachment-empty {
  margin-top: 14px;
  color: #909399;
  font-size: 13px;
}

@media screen and (max-width: 1366px) {
  .order-main,
  .page-title-row {
    display: block;
  }

  .order-stat-list {
    margin-top: 12px;
  }

  .page-summary {
    display: inline-block;
    margin-top: 10px;
  }

  .detail-attachment-header {
    display: block;
  }

  .detail-attachment-actions {
    margin-top: 12px;
  }
}
</style>
